import {QuestionList} from '../types';
import Orn1 from '../img/orn1.svg';
import Orn2 from '../img/orn2.svg';
import Orn3 from '../img/orn3.svg';
import Orn4 from '../img/orn4.svg';
import Orn5 from '../img/orn5.svg';
import RightAnswer2 from '../img/rightAns2.webp';

export const questionList: QuestionList = [{
    id: 1,
    img: Orn1,
    question: `Чим покривають дах української традиційної хати?`,
    rightAnswerId: 1,
    rightAnswerExplanation: `<p>
Правильна  відповідь <span>«Стріха»</span>. Це — солом’яна або очеретяна покрівля. Такий тип дахів зазвичай використовувався у лісостеповій і степовій зонах України. Для покриття стріхи використовують очерет у горстках або солому в кулях — обмолочених снопах. Залежно від напрямку колоскової частини кулів розрізняють «стріху під волоть» (колосками догори) і «стріху під гузир» (колосками донизу). Кулі, які клали на кутах стріхи, називаються наріжницями.
</p>
<p>
Музей Національної архітектури та побуту України у Пирогові був заснований у 1969 році. На початку 1970-х була створена вхідна група, яка не відновлювалася  понад 50 років. Попри це  музей відвідували багато туристів та іноземні делегації. Отже — нове обличчя музею — символ того, що українцям не байдуже на свій історичний спадок.
</p>
`,
    answers: [
        {
            id: 1,
            text: 'Стріха',
        },
        {
            id: 2,
            text: 'Маківка',
        },
        {
            id: 3,
            text: 'Картуш',
        },
        {
            id: 4,
            text: 'Присінок',
        },
    ],
},
    {
        id: 2,
        img: Orn2,
        question: `Що знаходиться одразу біля входу до Національного музею народної архітектури та побуту України?`,
        rightAnswerId: 2,
        rightAnswerExplanation: `
        <p>Біля входу до музею у Пирогові розташовано <span>дерев’яний вітряк</span>. Традиційні українські млини — це витвори народної інженерної думки, що забезпечували потреби старого українського села в доступній та безпечній енергії. Найстародавнішими на теренах України є водяні млини, вітряні з'явилися тільки у XVIII ст. Протягом декількох століть вони виробляли енергію за допомогою вітру й слугували людям водокачками, млинами і лісопильнями.</p>
<p>Новий вхід на територію музею у Пирогові, зроблений за сприяння благодійного фонду <a href = "https://mhpgromadi.org.ua/" target="_blank">«МХП-Громаді»</a>, спроєктований з урахуванням ландшафтних особливостей місцевості та туристичних запитів відвідувачів з України й світу. Він виконаний з дерева (сосна, смерека, дуб), металу та бетону. Графітовий колір у поєднанні з природним деревом робить всю композицію органічною частиною музею. </p>        
`,
        rightAnswerImg: RightAnswer2,
        answers: [
            {
                id: 1,
                text: 'Дерев’яна церква',
            },
            {
                id: 2,
                text: 'Дерев’яний вітряк',
            },
            {
                id: 3,
                text: 'Дерев’яний колодязь із «журавлем»',
            },
            {
                id: 4,
                text: 'Ярмаркове поле',
            },
        ],
    },
    {
        id: 3,
        img: Orn3,
        question: `Що таке Набожник?`,
        rightAnswerId: 3,
        rightAnswerExplanation: `
        <p>
        Набожник – одна з назв <span>вишитого рушника</span>, яким прикрашають ікони або благословляють (на дорогу, до шлюбу, до важливої події). З рушниками в українському побуті пов’язано багато традицій. Одна з них – дівчина обов’язково має вишити власний рушник. По тому визначали, яка вона господиня. Також вважалося, що чим більше рушників у хаті, тим більше достатку в родині.
</p>
<p>
Реконструкція центрального входу до музею — тільки перший етап реалізації масштабної державної програми «Магніти України». 2020-го року Національний музей народної архітектури та побуту України став одним із 4 учасників цієї програми як символ України, місце культурної дипломатії та української самоідентифікації. 
</p>`,
        answers: [
            {
                id: 1,
                text: 'Куток у хаті, де розташовано ікони',
            },
            {
                id: 2,
                text: 'Маленьке приміщення перед входом до церкви',
            },
            {
                id: 3,
                text: 'Вишитий рушник, яким прикрашають ікони',
            },
            {
                id: 4,
                text: 'Масляний світильник, які встановлюють по кутах житла',
            },
        ],
    },
    {
        id: 4,
        img: Orn4,
        question: `Які за принципом будівництва хати були розповсюджені на території степової та лісостепової України?`,
        rightAnswerId: 1,
        rightAnswerExplanation: `
        <p>
        <span>Мазанка</span> — хата, зроблена з глини, сирцевої цегли або хмизу, обмазаного глиною, замішаною на органічній речовині. Після цього стіни покривалися побілкою на вапні. Мазанки були поширені на території степової та лісостепової України, що пов'язано з природними умовами. В цих краях не так багато лісів, а отже й деревини для будівництва.
</p>
<p>Біля входу до Національного музею у Пирогові тепер також облагороджена територія: оглядовий майданчик, поремонтована огорожа. І це тільки перший етап. БФ <a href="https://mhpgromadi.org.ua/" target="_blank">«МХП-Громаді»</a> продовжуватиме реконструкцію та впорядкування території музею, щоб зробити його справжнім туристичним магнітом України.</p>`,
        answers: [
            {
                id: 1,
                text: 'Мазанки',
            },
            {
                id: 2,
                text: 'Кам’яниці',
            },
            {
                id: 3,
                text: 'Зруби',
            },
            {
                id: 4,
                text: 'Цегляні будинки',
            },
        ],
    },
    {
        id: 5,
        img: Orn5,
        question: `Що з цього відсутнє на території Національного музею народної архітектури та побуту України?`,
        rightAnswerId: 4,
        rightAnswerExplanation: `
        <p>
        У Пирогові немає <span>музею-колиби</span>. Але там регулярно проводяться ярмарки просто неба, де можна придбати предмети побуту, одяг, іграшки, їжу та напої. Також є кілька стаціонарних та пересувних закладів харчування. Регулярно проводяться етнічні фестивалі, майстер-класи з гончарства, тематичні народні та обрядові святкування, вистави фольклорних колективів. А ще – це чудова локація для сімейних прогулянок та фотосесій.
</p>
<p>
Новий центральний вхід – це своєрідний етнопортал, який переносить відвідувача із сучасного, технологічного, урбаністичного світу в давні українські села XVII-XX століття з їхньою історією, архітектурою, побутом, світоглядом та традицією. Це місце для комфортного відпочинку, отримання вичерпної інформації про історію та  діяльність музею та доступні послуги (екскурсії, майстер-класи, освітні лекторії, свята тощо).
</p>`,
        answers: [
            {
                id: 1,
                text: 'Сільська школа-музей XIX ст',
            },
            {
                id: 2,
                text: 'Музей плакату України',
            },
            {
                id: 3,
                text: 'Пасіка',
            },
            {
                id: 4,
                text: 'Музей-колиба козацьких часів',
            },
        ],
    },
    {
        id: 6,
        img: Orn1,
        question: `Як на Закарпатті називають сходи?`,
        rightAnswerId: 2,
        rightAnswerExplanation: `
        <p>
        В Закарпатській говірці сходи називаються <span>гарадичи</span>. Цікава не тільки назва, але й напрямок руху. «Гурі ґарадичами» – нагору, «долу ґарадичами» – вниз. Діалект, який ми зараз називаємо закарпатським, сформувався у XVIII столітті. Передумовою його формування є географічне положення регіону та історичні чинники – за останні кілька століть територія сучасного Закарпаття перебувала у складі різних держав. Діалект має українську основу та багато запозичених слів та виразів. Переважно з угорської, словацької, чеської, німецької та румунської мов.
</p>
<p>
Відповідальний бізнес має фінансово підтримувати такі ініціативи — наголошують у компанії «МХП». Від початку повномасштабної війни ця ідея набула ще більшого сенсу для всіх нас, бо це – про нашу силу, єднання й мотивацію працювати заради перемоги. 
</p>`,
        answers: [
            {
                id: 1,
                text: 'Паланки',
            },
            {
                id: 2,
                text: 'Гарадичи',
            },
            {
                id: 3,
                text: 'Драбина',
            },
            {
                id: 4,
                text: 'Приступець',
            },
        ],
    },
    {
        id: 7,
        img: Orn2,
        question: `Як називається незшита клітчата спідниця у традиційному українському жіночому вбранні?`,
        rightAnswerId: 3,
        rightAnswerExplanation: `
        <p>Незшита поясна частина жіночого українського національного вбрання в східній, південній і центральній Україні називається <span>плахтою</span>. Це полотнище довжиною до 4 метрів, виткане з завжди клітчатої пофарбованої вовни з вибагливим візерунком. Була поширеним елементом жіночого одягу за козацьких часів. З часом цей вид одягу замінили спідниці.</p>
<p>Музей містить чимало історично-туристичних атракцій, що приваблюють не лише українців, а й туристів з багатьох країн. А доопрацювання інфраструктури та підвищення в такий спосіб якості послуг допомогло б привернути увагу значно ширшого кола мандрівників і розказати про справжню незалежну Україну. </p>`,
        answers: [
            {
                id: 1,
                text: 'Керсетка',
            },
            {
                id: 2,
                text: 'Попередниця',
            },
            {
                id: 3,
                text: 'Плахта',
            },
            {
                id: 4,
                text: 'Дерга',
            },
        ],
    },
    {
        id: 8,
        img: Orn3,
        question: `Що таке Ванькир?`,
        rightAnswerId: 3,
        rightAnswerExplanation: `
        <p>
        <span>Ванькир</span> — маленька, кутова або бічна житлова кімната, відокремлена стіною від великої. В українських хатах, відділений від світлиці ванькир міг використовуватися як кухня, дитяча чи спальня.
</p>
<p>
Роботи з реконструкції вхідної групи музею розпочалися перед початком повномасштабної війни. Їхній реалізації не завадили ані масовані ракетні обстріли, ані регулярні вимкнення електроенергії. Адже всі ми разом продовжуємо жити, працювати та виборювати своє право на гідне існування у своїй ідентичності.
</p>`,
        answers: [
            {
                id: 1,
                text: 'Комора для зберігання запасів їжі на зиму',
            },
            {
                id: 2,
                text: 'Приміщення, де розташовані діжки для переброджування хмільних напоїв\n',
            },
            {
                id: 3,
                text: 'Невелика дощата прибудова до хати, яка використовувалася як літня кухня\n',
            },
            {
                id: 4,
                text: 'Маленька житлова кімната, відокремлена від великої',
            },
        ],
    },
    {
        id: 9,
        img: Orn4,
        question: `Яка з сучасних областей України не входила до складу Наддніпрянщини?`,
        rightAnswerId: 4,
        rightAnswerExplanation: `
        <p>
        Наддніпрянська Україна або Наддніпрянщина — історико-географічна частина України, яка початково включала в себе центральні і північні області з центром в Києві. Займає землі по ліву і праву сторони Дніпра, що лежать в безпосередній долині та малих і середніх річок-притоків Дніпра. В сучасних межах це територія Київської, Черкаської, Полтавської, Кіровоградської, а також частково Житомирської, Чернігівської, Сумської та Дніпропетровської областей. 
</p>
<p>
У межах втілення ініціативи «Магніти України» компанія МХП і благодійний фонд <a href="https://mhpgromadi.org.ua/" target="_blank">«МХП-Громаді»</a> відгукнулися на прохання Міністерства культури та інформаційної політики України й запропонували музею свій  патронат для підтримки цієї держпрограми. Бізнес взяв на себе розробку й фінансове забезпечення відродження НМНАПУ. 
</p>`,
        answers: [
            {
                id: 1,
                text: 'Київська',
            },
            {
                id: 2,
                text: 'Черкаська',
            },
            {
                id: 3,
                text: 'Полтавська',
            },
            {
                id: 4,
                text: 'Запорізька',
            },
        ],
    },
    {
        id: 10,
        img: Orn5,
        question: `Що таке Бурдей (бурдюг)?`,
        rightAnswerId: 1,
        rightAnswerExplanation: `
        <p>
        В Українській історії <span>«бурдей»</span> — «хата, викопана в землі, найпростіше житло самітнього козака на Запоріжжі IV-IVII ст. Певне розповсюдження мала також на Гуцульщині. За описом Дмитра Яворницького: «Всередині бурдюга не було ні печі, ні димаря: піч заміняла "мечеть", на котрій пекли хліб, та кабиця, на котрій варили страви, обидві робили з дикого каменю. В деяких бурдюгах зустрічалось якесь умеблювання: лави, зброя, образи, килими тощо. Бурдюги ніколи не замикались, тому вони були відкритими для всіх завжди».
</p>
<p>
В музеї представлена наша історія та культурне надбання. Це те, що хоче знищити ворог. Ось чому нам так важливо нині не тільки берегти й відновлювати все, що нас ідентифікує українцями, а й максимально знайомити світ з нашою культурою.
</p>`,
        answers: [
            {
                id: 1,
                text: 'Невелика козацька землянка в степу',
            },
            {
                id: 2,
                text: 'Низька призьба перед входом до хати',
            },
            {
                id: 3,
                text: 'Місце в хаті для зберігання господарського начиння',
            },
            {
                id: 4,
                text: 'Приміщення, де козаки збиралися для нарад та спілкуванн',
            },
        ],
    }

,];
